import React, { useEffect, useState } from "react";
import { useForm,Controller } from "react-hook-form";
import Axios from "axios";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner.js";
import ConsultantLayout from "../commonlayouts/consultantlayout.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {   GetCandidateById, GetHotList, GetJobRoles, sendBenchCandidateSubmission, PostHotList, siteURL, GetLatestPayrate } from "../apiconstants/constants.js";
import { useCountry } from "../contexts/countrycodecontext.js";
import WYSIWYGEditor from "../helpers/WYSIWYGEditor.js";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import {Modal, Button } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
const ShareBenchCandidateDettoRecruiter = () => {
    const { register, handleSubmit,watch, getValues,formState: { errors, isSubmitting }, setValue, reset ,control} = useForm();
    let query = useQuery();
    const guid = query.get("guid");
    const [isDisabled, setIsDisabled] = useState(false);
        const [selectedCCEmail, setSelectedCCEmail] = useState("bench.us@knackhook.com");

    const [isLoading, setIsLoading] = useState(false);
    const {selectedCountry} = useCountry();
    const [previewHtml, setPreviewHtml] = useState("");
const [showPreview, setShowPreview] = useState(false);
  const [subvendors, setSubvendors] = useState([]);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [pageCount, setPageCount] = useState(0);
const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(8);
    const [tierFilter, setTierFilter] = useState('');
    const [selectedVendors, setSelectedVendors] = useState([]);
      const [loading, setLoading] = useState(false);
     const [searchTerm, setSearchTerm] = useState("");
    const [editingField, setEditingField] = useState({ index: null, field: null });
    const [editedValue, setEditedValue] = useState("");
 const { register: registerModal, handleSubmit: handleSubmitModal, formState: { errors: modalErrors }, reset: resetModal } = useForm({
  defaultValues: {
    name: "",
    emailId: "",
    phone: "",
    company: "",
    website: "",
    tierType: "",
    description: "",
    type: ""
  }
});

const [showAddModal, setShowAddModal] = useState(false);
   const [tier,setTier] = useState([
    {tierID:"Tier 1",tierName:"Tier 1"},
    {tierID:"Tier 2",tierName:"Tier 2"},
    {tierID:"Tier 3",tierName:"Tier 3"},
])
  const [type,settype] = useState([
    {statusID:"1",statusName:"Recruiter"},
    {statusID:"2",statusName:"BenchSales"}])
const token = localStorage.getItem("jwtToken");
    const handleOpen = () => setShowAddModal(true);
const handleClose = () => setShowAddModal(false);

const fieldOptions = [
  { label: "Full Name", value: "FullName" },
  { label: "Email", value: "Email" },
  { label: "Mobile Number", value: "MobileNumber" },
  { label: "Gender", value: "Gender" },
  { label: "Job Role", value: "JobRole" },
  { label: "Work Mode", value: "WorkMode" },
  { label: "Educational Qualification", value: "QualificationID" },
  { label: "Resume", value: "Resume" },
  { label: "Driving licence", value: "DrivingLicence" },
   { label: "I-94", value: "I-94" },
  { label: "Others", value: "Others" },
  { label: "Technical Skill", value: "TechnicalSkill" },
  { label: "Experience", value: "Experience" },
  { label: "Date of Birth", value: "DOB" },
  { label: "Address", value: "Address" },
  { label: "Marital Status", value: "MaritalStatus" },
  { label: "Profile Summary", value: "ProfileSummery" },
  { label: "Current Visa & First US Entry", value: "WorkAuthorizationandValidity" },
 { label: selectedCountry == 2 ? "Bill Rate" : "Expected CTC",  value: "BillRate" },
  { label: selectedCountry == 2 ? "Pay Rate" : "Current CTC",  value: "PayRate" },
  { label: "Employer Name", value: "EmployerName" },
   { label: "SSN", value: "SSN" },
   { label: "Passport No", value: "PassportNo" },
  { label: "Two Recent References", value: "Tworefrencesfromrecentproject" },
  { label: "Visa / Aadhar", value: "VisaCopy" },
  
  { label: "Passport", value: "Passport" },
    { label: "RTR_PDF", value: "RTR_PDF" },

  { label: "LinkedIn URL", value: "LinkedInUrl" },
  { label: "Certifications", value: "Certifications" },
  { label: "Client Status", value: "clientStatus" },
  { label: "Willing to Relocate", value: "WillingToRelocate" },
    { label: "Availability for Joining", value: "AvailabilityToJoin" },
      { label: "Availability to Interview", value: "AvailabilityToInterview" },
         { label: "Assessment Link", value: "Assessment" },
   { label: "Resume_Insights_Pdf", value: "Resume_Insights_Pdf" },
   { label: "Custom Assessment Link", value: "CustomAssessmentLink" },
   { label: "Skill Metrics", value: "SkillMetrics" },
];
const defaultCheckedFields = [
  "FullName",
  "Email",
  "MobileNumber",
  // "JobRole",
  "PassportNo",
  "DOB",
  "DrivingLicence",
  "I-94",
   "WorkAuthorizationandValidity",
    "Address",
  "SSN",
  "LinkedInUrl",
  "QualificationID",
      "AvailabilityToInterview",
 "Certifications",
  "WillingToRelocate",
  "AvailabilityToJoin",
 "Resume"
   
];


const [jobRoles, setJobRoles] = useState([]);
const [candidateDetails, setCandidateDetails] = useState([]);
const initialCheckedFields = defaultCheckedFields.includes("QualificationID")
  ? [...defaultCheckedFields, "HighestEducation"]
  : defaultCheckedFields;
   const navigate = useNavigate();

const [selectedFields, setSelectedFields] = useState(initialCheckedFields);
// const [selectedFields, setSelectedFields] = useState(defaultCheckedFields);
    let Guid="";
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    const candidateMobileNumber = localStorage.getItem("mobileNumber");
    const fullName = localStorage.getItem("firstName");
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    const handlePageClick = (e) => {
        setCurrentPage(e.selected);
    };
      const handleTierFilterChange = (e) => {
  setTierFilter(e.target.value);
};
const handleCheckboxChange = (vendor, checked) => {
  if (checked) {
    // Only keep the newly selected vendor
    setSelectedVendors([vendor]);
  } else {
    // If unchecked, clear the selection
    setSelectedVendors([]);
  }
};


const handleFieldChange = (fieldValue) => {
  setSelectedFields((prev) => {
    let updated = [...prev];

    if (updated.includes(fieldValue)) {
      // Unchecking
      updated = updated.filter(f => f !== fieldValue);
      if (fieldValue === "QualificationID") {
        updated = updated.filter(f => f !== "HighestEducation");
      }
    } else {
      // Checking
      updated.push(fieldValue);
      if (fieldValue === "QualificationID") {
        updated.push("HighestEducation");
      }
    }

    return [...new Set(updated)];
  });
};



const fetchCandidateDetails = async () => {
  setIsLoading(true);
  const GetapiUrl = GetCandidateById.APIURL;
  const fliterdata = { guid: guid };

  try {
    const result = await Axios.post(GetapiUrl, fliterdata);
    const data = result.data;
    setCandidateDetails([data]);
  } catch (error) {
    console.error("Failed to fetch candidate details:", error);
  } finally {
    setIsLoading(false);
  }
};
 const jobRoleOptions = jobRoles.map(role => ({
  value: role.jobRoleId,
  label: role.jobRole
}));
  
    const fetchJobRoles = () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        Axios.get(getApiUrl).then((response) => {
            setJobRoles(response.data);
        }).catch((error) => {
            console.error("Error fetching job roles", error);
        });
    };
        const getJobRoleName = (id) => {
        const jobRole = jobRoles.find(role => role.jobRoleId == id);
        return jobRole ? jobRole.jobRole : "";
    };
      const fetchSubvendors = async () => {
            setLoading(true);
      try {
        const response = await Axios.get(
         `${GetHotList.APIURL}?UserGuid=${userguid}&countryId=${selectedCountry}`,
          {            headers: {   
                       Authorization: `Bearer ${token}`   
                               }          }

        );
        const filteredRecruiters = response.data?.filter((x)=>x.type=='Recruiter' && x.isActive == true)
        setSubvendors(filteredRecruiters);
         setPageCount(Math.ceil(filteredRecruiters?.length / itemsPerPage));
      } catch (error) {
        console.error('Error fetching subvendor data:', error);
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
  
    if (isAccordionOpen && Guid && selectedCountry) {
      fetchSubvendors();
    }
  }, [isAccordionOpen, Guid, selectedCountry]);
  
const filteredSubvendors = subvendors.filter((v) => {
  const matchesTier = tierFilter ? v.tierType === tierFilter : true;
  const matchesSearch = `${v.name} ${v.emailId}`.toLowerCase().includes(searchTerm.toLowerCase());
  return matchesTier && matchesSearch;
});

// Slice for pagination
const offset = currentPage * itemsPerPage;
const currentPageVendors = filteredSubvendors.slice(offset, offset + itemsPerPage);

useEffect(() => {
  setPageCount(Math.ceil(filteredSubvendors.length / itemsPerPage));
}, [filteredSubvendors]);


const generatePreviewTemplate = (formData) => {
  const candidate = candidateDetails[0] || {}; 
  const rows = [
    { label: "Full Name", value: candidate.fullName, key: "FullName" },
    { label: "Email", value: candidate.email, key: "Email" },
    { label: "Mobile Number", value: candidate.mobileNumber, key: "MobileNumber" },
    { label: "LinkedIn URL", value: candidate.linkedInUrl, key: "LinkedInUrl" },
    { label: "Experience", value: candidate.experience, key: "Experience" },
    { label: "Highest Education", value: candidate.highestEducation ? candidate.highestEducation: candidate.courseName, key: "HighestEducation" },
    { label: "Work Mode", value: candidate.workMode, key: "WorkMode" },
    { label: "Gender", value: candidate.gender, key: "Gender" },
    { label: "Date of Birth(YYYY-MM-DD)", value: candidate.dob, key: "DOB" },
    { label: "Current Location", value: candidate.address, key: "Address" },
    { label: "Marital Status", value: candidate.maritalStatus, key: "MaritalStatus" },
    { label: "Profile Summary", value: candidate.profileSummery, key: "ProfileSummery" },
    { label: "Technical Skill", value: candidate.technicalSkill, key: "TechnicalSkill" },
    { label: "VISA / US Entry (Visa Type/Year)", value: candidate.workAuthorizationandValidity, key: "WorkAuthorizationandValidity" },
    { label: selectedCountry == 2 ? "Bill Rate" : "Expected CTC", value: candidate.billRate, key: "BillRate" },
    { label: selectedCountry == 2 ? "Pay Rate" : "Current CTC", value: candidate.payRate, key: "PayRate" },
    { label: "Employer Name", value: candidate.employerName, key: "EmployerName" },
    { label: "4 Digits SSN", value: candidate.ssn, key: "SSN" },
    { label: "Passport No", value: candidate.passportNo, key: "PassportNo" },
    { label: "Two Recent References", value: candidate.tworefrencesfromrecentproject, key: "Tworefrencesfromrecentproject" },
    { label: "Certifications", value: candidate.certifications, key: "Certifications" },
    { label: "Client Status", value: candidate.clientStatus, key: "clientStatus" },
    { label: "Willing to Relocate", value: candidate.willingToRelocate, key: "WillingToRelocate" },
    { label: "Availability to Join", value: candidate.availabilityToJoin, key: "AvailabilityToJoin" },
    { label: "Availability to Interview", value: candidate.availabilityToInterview, key: "AvailabilityToInterview" },
{ 
  label: "Custom Assessment Link",  
  value: candidate?.customAssessmentLink 
    ? `<a href="${candidate.customAssessmentLink}" target="_blank" style="color: #007bff; text-decoration: underline;">${candidate.customAssessmentLink}</a>` 
    : null,  
  key: "CustomAssessmentLink" 
},
{ 
  label: "Assessment Link", 
  value: `<a href="${siteURL}/HomeViewAssessmentVideo?Guid=${guid}" target="_blank" style="color: #007bff; text-decoration: underline;">${siteURL}/HomeViewAssessmentVideo/?Guid=${guid}</a>`, 
  key: "Assessment"  
},

  ];

  const tableRows = rows.filter(row =>
  selectedFields.includes(row.key) &&
  row.value !== null &&
  row.value !== "null" &&
  row.value !== "" &&
  row.value !== "N/A"
)


    .map(row => `
      <tr>
        <td style="padding: 8px; border: 1px solid #ccc;"><strong>${row.label}</strong></td>
        <td style="padding: 8px; border: 1px solid #ccc;">${row.value || ''}</td>
      </tr>
    `)
    .join("");
      let skillMetricsTable = "";
  if (candidate.skillMetrics && candidate.skillMetrics !== "null") {
    try {
      const skills = JSON.parse(candidate.skillMetrics || "[]");
      if (skills.length) {
        skillMetricsTable = `
          <h5 style="margin-top: 20px;">Skill Metrics:</h5>
          <table style="width:100%; border-collapse: collapse; font-size: 14px; margin-bottom: 20px;">
            <thead>
              <tr>
                <th style="border: 1px solid #ccc; padding: 6px;">Skill</th>
                <th style="border: 1px solid #ccc; padding: 6px;">Number of years of exp</th>
                <th style="border: 1px solid #ccc; padding: 6px;">Rating (1-5)</th>
              </tr>
            </thead>
            <tbody>
              ${skills
                .map(
                  (s) => `
                <tr>
                  <td style="border: 1px solid #ccc; padding: 6px;">${s.Skill}</td>
                  <td style="border: 1px solid #ccc; padding: 6px;">${s.YearsOfExp}</td>
                  <td style="border: 1px solid #ccc; padding: 6px;">${s.Rating}</td>
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
        `;
      }
    } catch (err) {
      console.error("Invalid SkillMetrics JSON:", err);
    }
  }

  return `
    <div style="font-family: Arial, sans-serif; line-height: 1.6;">
      <p>Hi ${selectedVendors[0]?.name || ""},</p>
      <p><strong>Greetings from KnackHook !!!</strong></p>
      <p>Please find the candidate's details below. The supporting documents have been attached.</p>

      <h4>Candidate Details:</h4>
      <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
        ${tableRows}
      </table>

       ${skillMetricsTable}

      <h5 class="mt-3">Job Description:</h5>
      <p>${formData.jobDescription || "N/A"}</p>

      <strong>Best Regards,</strong><br/>
       <strong>KnackHook Staffing Team,</strong><br/>
  ✉️ <a href="mailto:${email}">${email},</a><br/>
  📞 ${candidateMobileNumber}<br/>
    </div>
  `;
};

const onSubmitStaffingContact = async (data) => {
  debugger
  await AddData(data);
  resetModal(); // clears modal fields
  setShowAddModal(false);
};


const AddData = async (data) => {
  const params = {
    name: data.name,
    emailId: data.emailId,
    phone: data.phone,
    company: data.company,
    website: data.website,
    country: selectedCountry,
    type: data.type || 'Recruiter',
    tierType: data.tierType || "Tier 1",
    description: data.description,
    createdBy: email,
    userGuid: userguid,
    countryID: selectedCountry,
  };

  const apiUrl = PostHotList.APIURL;

  Axios.post(apiUrl, params,
     { headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

  )
    .then((result) => {
      if (result.data.message === "Inserted successfully.") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Added Successfully",
          showConfirmButton: false,
          timer: 5000,
        });
        
        // ✅ close modal instead of navigating away
        fetchSubvendors();
        setShowAddModal(false);

        // ✅ update table dynamically (optional)
        // fetchContacts(); 
      } else if (
        result.data.message === "duplicate Record  based on EmailId."
      ) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Staffing Contact exists!",
          showConfirmButton: false,
          timer: 5000,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Issue with data format!",
          showConfirmButton: false,
          timer: 5000,
        });
      }
    })
    .catch((error) => {
      console.log("Error", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "API Error!",
        text: error.message,
      });
    });
};

const onSubmit = async (data, e) => {
  e.preventDefault();

  // ✅ Prepare vendors list
  const selectedVendorList = selectedVendors.map(v => ({
    recruiterGuid: v.guid,
    toEmail: v.emailId,
  }));

  if (selectedVendorList.length === 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Please select at least one staffing contact.',
      showConfirmButton: true,
    });
    return;
  }

  setIsLoading(true); // start spinner once here

  let billRatetoSubmit = "";
  let apiBillRate = 0;

  try {
    // ✅ Only handle BillRate if selected
    if (selectedFields.includes("BillRate")) {
      try {
        const billrateResponse = await Axios.post(GetLatestPayrate.APIURL, {
          benchSalesGuid: userguid,
          candidateGuid: guid,
          staffingGuid: selectedVendors[0]?.guid,
          jobRole: data?.jobRole?.value?.toString() || "",
        },
          { headers: { Authorization: `Bearer ${token}` } });

        if (
          billrateResponse.data &&
          billrateResponse.data !== "No BillRate found for the given details."
        ) {
          apiBillRate = billrateResponse.data.billRate || 0;
        } else {
          apiBillRate = 0;
        }
      } catch (error) {
        console.log("Get Payrate API Error:", error);
        apiBillRate = 0;
      }

      // Stop loader before showing popup (so UI doesn't lock)
      setIsLoading(false);

      const { value: enteredBillRate } = await Swal.fire({
        title: "Submit Candidate",
        html: `
          <p>Billrate from system: <strong>${apiBillRate}</strong></p>
          <p>Enter custom billrate if different:</p>
        `,
        input: "text",
        inputPlaceholder: "Enter billrate",
        inputValue: apiBillRate.toString(),
        showCancelButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
      });

      // If user cancelled, stop completely
      if (enteredBillRate === undefined) return;

      billRatetoSubmit = enteredBillRate || 0;

      // Restart loader for submission
      setIsLoading(true);
    }
const transformedFields = selectedFields.map(f => {
  if (f === "I-94") return "[I-94]";
  return f;
});

    // ✅ Call submission API
    const params = {
      vendorEmail: selectedVendors[0]?.emailId,
      vendorName: selectedVendors[0]?.name,
      subject: data.subject,
      jobRole: data?.jobRole?.value?.toString(),
      jobDescription: data.jobDescription,
      countryID: selectedCountry,
      emailCC: selectedCCEmail,
      candidateGuid: guid,
      userGuid: userguid,
      guid: userguid,
      staffingGuid: selectedVendors[0]?.guid,
      ...(selectedFields.includes("BillRate") && { billRate: billRatetoSubmit }),
      fieldJson: { fields: transformedFields },
    };

    const result = await Axios.post(sendBenchCandidateSubmission.APIURL, params,
      { headers: { Authorization: `Bearer ${token}` } } 
    );

    if (result.data.message === "Email sent successfully.") {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Email sent Successfully",
        showConfirmButton: false,
        timer: 5000,
      });
      navigate("/Employer/InternalBench");
    } else if (result.data.message === "User is not a Bench Sales user. Email not sent.") {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Your user type is not Bench Sales, so mail can't be sent!",
        showConfirmButton: false,
        timer: 5000,
      });
    } 
     else if (result.data.message.includes("Email sending failed") ||
  result.data.message.includes("Internal server error") ||
  result.data.message.includes("exceed the 30MB limit")) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Some docs exceeded the limit. Please check.",
        showConfirmButton: false,
        timer: 5000,
      });
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Add correct Details",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  } catch (error) {
    console.log("Submit API Error:", error);
    Swal.fire({
      icon: "error",
      title: "Something went wrong",
      text: error.message,
    });
  } finally {
    // ✅ Always stop spinner at the end
    setIsLoading(false);
  }
};


    useEffect(() => {
          setSelectedVendors([]);
        fetchCandidateDetails();
        fetchJobRoles();
    }, [selectedCountry]);

     const isVendorSelected = (vendorId) =>
  selectedVendors.some((v) => v.hotListID === vendorId);

      const formatCandidateDetails = (candidate) => {
       const safe = (label, value) => {
         const clean = value?.toString().trim();
         return clean && clean !== "null" ? `${label}: ${clean}` : null;
       };
     
       const lines = [
         safe("Name", candidate.fullName?.split(" ")[0]),
         safe("Job Role", candidate.jobRoleName),
         safe("Experience", candidate.experience),
         safe("Location", candidate.location || candidate.preferredLocation),
         safe("Visa Status", candidate.workAuthorizationandValidity),
         safe("Availability", candidate.availability || "Immediate")
       ].filter(Boolean);
     
       return lines.length
         ? `${lines.join("<br/>")}`
         : "";
     };
     const jobRole = watch("jobRole");
     
       const safeValue = (val) => (val === "null" ||val === null || val === undefined ? "" : val);

     useEffect(() => {
       if (!jobRole?.label || candidateDetails.length === 0) return;
     
       const firstNames = candidateDetails
         .map((c) => safeValue(c.fullName)?.split(" ")[0])
         .filter(Boolean)
         .join(", ");
     
       const defaultSubject = `KnackHook Submission - ${jobRole.label} - Profile - ${firstNames}`;
     
       const formattedCandidates = candidateDetails
         .map(formatCandidateDetails)
         .filter(Boolean)
         .join("<br/><br/>");
     
    //    const defaultContent = `
    //  Hello ${selectedVendors[0]?.name},<br/>
     
    //  Greetings from KnackHook!<br/>
     
    //  I hope you are doing well.<br/>
     
    //  This is  ${fullName}, Sr. Bench Sales Recruiter at KnackHook. I’m reaching out to share the profile of a highly experienced consultant who is currently available for new opportunities.<br/><br/>
    //  Candidate Details: <br/><br/>
    //  ${formattedCandidates}<br/><br/>

    //  Please let me know if you have any suitable openings or need further information.<br/>
    //  Looking forward to hearing from you.
    //  `;
     
       // Only update if values actually changed
       const currentValues = getValues();
       if (
         currentValues.subject !== defaultSubject
        //  currentValues.jobDescription !== defaultContent
       ) {
        //  setSubject(defaultSubject);
         reset({
           ...currentValues,
           subject: defaultSubject,
          //  jobDescription: defaultContent,
         });
       }
     }, [jobRole, candidateDetails,selectedVendors]);
     
     const startEditing = (index, field, currentValue) => {
       setEditingField({ index, field });
       setEditedValue(currentValue);
     };
     
     
     const saveFieldValue = (index, field) => {
       const updatedData = [...candidateDetails];
       updatedData[index][field] = editedValue;
       setCandidateDetails(updatedData);
       setEditingField({ index: null, field: null });
     };
     
     const handleKeyDown = (e, index, field) => {
       if (e.key === "Enter") {
         saveFieldValue(index, field);
       }
     };
     
    return (
        <ConsultantLayout>
            <section>
                {isLoading ? <center><LoadingSpinner /></center> :
                    <div className="container-fluid mt-4 pb-5">
                                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                     <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
  <Link to="/Employer/InternalBench">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Share Bench Candidate Details to Recruiter</h2>
  </div>
  {/* <button onClick={handleClick} disabled={isSubmitting || isDisabled} className="btn btn-primary">
                                Copy
                            </button> */}
</div>

                        <hr />
                                                <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>

                     <div className="accordion" id="subvendorAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header"   >
          <button
            className={`accordion-button ${!isAccordionOpen ? 'collapsed' : ''}`}
            type="button"
            style={{ color: "#00a7ac" }}
            onClick={() => setIsAccordionOpen(prev => !prev)}
          >
            Staffing Contact Details
          </button>
        </h2>
        <div
          className={`accordion-collapse collapse ${isAccordionOpen ? 'show' : ''}`}
          aria-labelledby="headingOne"
        >
          <div className="accordion-body">
  {loading ? (
    <p>Loading staffing contacts...</p>
  ) : (
    <>
      {/* Search and Filter Row */}
      <div className="d-flex justify-content-between mb-3">
        {/* Search Input */}
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ width: '200px' }}
          placeholder="Search by name or email"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(0); // reset to first page on search
          }}
        />

        {/* Tier Filter */}
        <div className="d-flex align-items-center gap-1">
          <span style={{ fontSize: '12px' }}>Tier Type</span>
          <select
            value={tierFilter}
            onChange={handleTierFilterChange}
            className="form-select form-select-sm"
            style={{ width: '150px', fontSize: '12px', marginLeft: 5 }}
            title="Filter Tier"
          >
            <option value="">All</option>
            <option value="Tier 1">Tier 1</option>
            <option value="Tier 2">Tier 2</option>
            <option value="Tier 3">Tier 3</option>
          </select>
        </div>
                  <button className="btn btn-primary mr-3" onClick={handleOpen} btn-ype="button"><i className="fa fa-plus"></i></button>

      </div>

      {/* Table */}
      <table
        className="table"
        style={{
          minWidth: "100%",
          fontSize: "12px",
          marginBottom: "12px",
          wordWrap: "break-word",
        }}
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Company</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Tier Type</th>
            <th>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {currentPageVendors.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">
                No staffing contacts found.
              </td>
            </tr>
          ) : (
            currentPageVendors.map((vendor, index) => (
              <tr key={vendor?.id || index}>
                <td>{vendor.name || '-'}</td>
                <td>{vendor.company || '-'}</td>
                <td>{vendor.emailId || '-'}</td>
                <td>{vendor.phone || '-'}</td>
                <td>{vendor.tierType || '-'}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={isVendorSelected(vendor.hotListID)}
                    onChange={(e) => handleCheckboxChange(vendor, e.target.checked)}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {currentPageVendors.length > 0 && (
        <div className="mt-3">
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        </div>
      )}
    </>
  )}
</div>
        </div>
      </div>
    </div>
                        <div class="row">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className=" ">
                                    <div className="mt-3">

                                          <input
                                            type="text"
                                            {...register("emailCC")}
                                            className={`form-control basic-form mt-3`}
                                            placeholder="CC Email"
                                            value={selectedCCEmail}
                                            onChange={e=>setSelectedCCEmail(e.target.value)}
                                        />
                                        </div>

  <div className="mt-3">
    <Controller
      name="jobRole"
      control={control}
      rules={{ required: "Job Role Required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={jobRoleOptions}
          placeholder="Select Job Role"
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
          styles={{
            control: (base, state) => ({
              ...base,
              height: 50,
              borderRadius: 15,
              fontSize: 12,
              borderColor: errors.jobRole ? "red" : base.borderColor,
            }),
             menuPortal: base => ({ ...base, zIndex: 9999 }) // ⬅️ very important
          }}
        />
      )}
    />
    {errors.jobRole && (
      <span className="text-danger">{errors.jobRole.message}</span>
    )}
  </div>

   <div>
                <input type="text" title='' placeholder='Subject' {...register("subject", { required: "Subject Required" })} id="subject" name="subject"
                  disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.subject ? 'is-invalid' : ''}`}
                />
              <div className="invalid-feedback"> {errors.subject?.message}</div>
            </div>                                      

<label className="mt-3"> Job Description </label>
                                                <Controller
                                                  name="jobDescription"
                                                  control={control}
                                                  rules={{ required: "Job Description Required" }}
                                                  style=
                                                  {{margin:'0'}}
                                                  render={({ field }) => (
                                                    <div>
                                                      <WYSIWYGEditor
                                                        {...field}
                                                        inputExtraProps={{ required: true }}
                                                      />
                                                      {errors.jobDescription && <div className="text-danger">{errors.jobDescription.message}</div>}
                                                    </div>
                                                  )}
                                                />
<div className="mt-4">
   <h5>Select Fields to Share:</h5>

  {/* Basic Details */}
  <div className="field-section">
    <h6 className="section-title" style={{ color: "#00a7ac" }}>Basic Details</h6>
    <div className="row">
      {fieldOptions
        .filter(field => defaultCheckedFields.includes(field.value) &&
                         !["Resume", "VisaCopy", "DrivingLicence","I-94","Passport","RTR_PDF"].includes(field.value))
        .map((field, idx) => (
          <div className="col-md-2 field-col" key={`basic-${idx}`}>
            <div className="form-check custom-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={`basic-${idx}`}
                checked={selectedFields.includes(field.value)}
                onChange={() => handleFieldChange(field.value)}
              />
              <label className="form-check-label" htmlFor={`basic-${idx}`}>
                {field.label}
              </label>
            </div>
          </div>
        ))}
    </div>
  </div>

  {/* Attachment Details */}
  <div className="field-section mt-4">
    <h6 className="section-title" style={{ color: "#00a7ac" }}>Attachments</h6>
    <div className="row">
      {fieldOptions
        .filter(field => ["Resume",  "DrivingLicence","I-94","VisaCopy","Passport","RTR_PDF","Resume_Insights_Pdf","Others"].includes(field.value))
        .map((field, idx) => (
          <div className="col-md-2 field-col" key={`attachment-${idx}`}>
            <div className="form-check custom-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={`attachment-${idx}`}
                checked={selectedFields.includes(field.value)}
                onChange={() => handleFieldChange(field.value)}
              />
              <label className="form-check-label" htmlFor={`attachment-${idx}`}>
                {field.label}
              </label>
            </div>
          </div>
        ))}
    </div>
  </div>

  {/* Additional Details */}
  <div className="field-section mt-4">
    <h6 className="section-title" style={{ color: "#00a7ac" }}>Additional Details</h6>
    <div className="row">
      {fieldOptions
        .filter(field =>
          !defaultCheckedFields.includes(field.value) &&
          !["Resume", "VisaCopy", "DrivingLicence","Passport","I-94","RTR_PDF","Resume_Insights_Pdf","Others"].includes(field.value)
        )
        .map((field, idx) => (
          <div className="col-md-2 field-col" key={`additional-${idx}`}>
            <div className="form-check custom-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={`additional-${idx}`}
                checked={selectedFields.includes(field.value)}
                onChange={() => handleFieldChange(field.value)}
              />
              <label className="form-check-label" htmlFor={`additional-${idx}`}>
                {field.label}
              </label>
            </div>
          </div>
        ))}
    </div>
  </div>
</div>




                                                {/* <div className="invalid-feedback"> {errors.detailsType?.message}</div> */}
                                    {/* </div> */}
                                </div>

     <div className="col-12 mt-4" style={{ overflowX: "auto", width: "100%" }}>
                    <label style={{ color: "#00a7ac", marginTop: 10 }}>Candidates Information</label>
                  <table className="table table-bordered" style={{ fontSize: "12px" }}>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Job Role</th>
                        <th>Current Visa & First US Entry</th>
                        <th>Relocation</th>
                        <th>Experience</th>
                       
                      </tr>
                    </thead>
                   <tbody>
  {candidateDetails?.map((data, index) => (
    <tr key={index}>
      {/* Full Name */}
      <td>
       

        {editingField.index === index && editingField.field === "fullName" ? (
  <input
    value={editedValue}
    autoFocus
    onChange={(e) => setEditedValue(e.target.value)}
    onBlur={() => saveFieldValue(index, "fullName")}
    onKeyDown={(e) => handleKeyDown(e, index, "fullName")}
  />
) : (
  <>
    {safeValue(data.fullName)?.split(" ")[0]} {/* Only first name */}
    &nbsp;
    <span
      onClick={() =>
        startEditing(index, "fullName", safeValue(data.fullName)?.split(" ")[0]) // ✏️ Pass only first name
      }
      style={{ cursor: "pointer", color: "gray" }}
    >
      ✏️
    </span>
  </>
)}

      </td>

      {/* Job Role */}
   <td>
  {editingField.index === index && editingField.field === "jobRoleName" ? (
    <input
      value={editedValue}
      autoFocus
      onChange={(e) => setEditedValue(e.target.value)}
      onBlur={() => saveFieldValue(index, "jobRoleName")}
      onKeyDown={(e) => handleKeyDown(e, index, "jobRoleName")}
    />
  ) : (
    <>
      {safeValue(data.jobRoleName) || getJobRoleName(data.jobRole)} {/* ✅ fallback */}
      &nbsp;
      <span
        onClick={() =>
          startEditing(
            index,
            "jobRoleName",
            safeValue(data.jobRoleName) || getJobRoleName(data.jobRole) // ✅ use fallback value for editing
          )
        }
        style={{ cursor: "pointer", color: "gray" }}
      >
        ✏️
      </span>
    </>
  )}
</td>


      {/* Work Auth */}
      <td>
        {editingField.index === index &&
        editingField.field === "workAuthorizationandValidity" ? (
          <input
            value={editedValue}
            autoFocus
            onChange={(e) => setEditedValue(e.target.value)}
            onBlur={() =>
              saveFieldValue(index, "workAuthorizationandValidity")
            }
            onKeyDown={(e) =>
              handleKeyDown(e, index, "workAuthorizationandValidity")
            }
          />
        ) : (
          <>
            {safeValue(data.workAuthorizationandValidity)}
            &nbsp;
            <span
              onClick={() =>
                startEditing(
                  index,
                  "workAuthorizationandValidity",
                  safeValue(data.workAuthorizationandValidity)
                )
              }
              style={{ cursor: "pointer", color: "gray" }}
            >
              ✏️
            </span>
          </>
        )}
      </td>

    <td>
{editingField.index === index && editingField.field === "relocation" ? (
  <input
    value={editedValue}
    autoFocus
    onChange={(e) => setEditedValue(e.target.value)}
    onBlur={() => saveFieldValue(index, "relocation")}
    onKeyDown={(e) => handleKeyDown(e, index, "relocation")}
  />
) : (
  <>
    {safeValue(data.relocation) || "Yes"} {/* Show Yes if null */}
    &nbsp;
    <span
      onClick={() =>
        startEditing(index, "relocation", safeValue(data.relocation) || "Yes")
      }
      style={{ cursor: "pointer", color: "gray" }}
    >
      ✏️
    </span>
  </>
)}

</td>
      {/* Experience */}
      <td>
        {editingField.index === index && editingField.field === "experience" ? (
          <input
            value={editedValue}
            autoFocus
            onChange={(e) => setEditedValue(e.target.value)}
            onBlur={() => saveFieldValue(index, "experience")}
            onKeyDown={(e) => handleKeyDown(e, index, "experience")}
          />
        ) : (
          <>
            {safeValue(data.experience)}
            &nbsp;
            <span
              onClick={() =>
                startEditing(index, "experience", safeValue(data.experience))
              }
              style={{ cursor: "pointer", color: "gray" }}
            >
              ✏️
            </span>
          </>
        )}
      </td>

    
    </tr>
  ))}
</tbody>

                  </table>
                </div>



                                <div class="row mb-4 mt-3 ">
                              <div className="col-12 d-flex justify-content-end gap-2 mb-3">

 
<button
    type="button"
    className="btn btn-primary"
    onClick={handleSubmit((formData) => {
      const html = generatePreviewTemplate(formData);
      setPreviewHtml(html);
      setShowPreview((prev) => !prev); // toggle
    })}
  >
    {showPreview ? "Hide Preview" : "Preview Email"}
  </button>

  <button
    id="svbutton"
    className="btn btn-primary pf-save"
    disabled={isSubmitting || isDisabled}
  >
    {isSubmitting && (
      <span className="spinner-border spinner-border-sm mr-1"></span>
    )}
    Share
  </button>
 <Link to="/Employer/GetCandidatesByEmployerUserID">
    <button
      type="button"
      className="btn btn-primary"
      disabled={isSubmitting || isDisabled}
    >
      Cancel
    </button>
  </Link>
  
</div>

                                </div>
                            </form>
                            {showPreview && (
  <div className="card mt-4 p-3" style={{ border: "1px solid #ccc" ,fontSize:14}}>
    <h4>Email Preview</h4>
    <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
  </div>
)}

                        </div>
                      
                        </div>
                    </div>
                }

                 <Modal show={showAddModal} onHide={handleClose} centered size="lg">
                  <Modal.Header closeButton>
                    <Modal.Title style={{ color: "#00a7ac" }}>Add Staffing Contact</Modal.Title>
                  </Modal.Header>
                
                  <Modal.Body>
                <form onSubmit={handleSubmitModal(onSubmitStaffingContact)}>
                        <div className="row">
                        {/* Left Column */}
                        <div className="col-md-6">
                          {/* Name */}
                          <OverlayTrigger
                            placement="bottom"
                            overlay={(props) => <Tooltip id="tooltip" {...props}>Name</Tooltip>}
                          >
                            <input
                              type="text"
                              name="name"
                              {...registerModal("name", { required: "Name Required" })}
                              placeholder="Name"
                              className={`form-control basic-form mt-3 ${
                                modalErrors.name ? "is-invalid" : ""
                              }`}
                            />
                          </OverlayTrigger>
                          <div className="invalid-feedback">{modalErrors.name?.message}</div>
                
                          {/* Email */}
                          <input
                            type="email"
                            name="emailId"
                            {...registerModal("emailId", { required: "Email Required" })}
                            placeholder="Email"
                 className={`form-control basic-form mt-3 ${
                                modalErrors.emailId ? "is-invalid" : ""
                              }`}          />
                          <div className="invalid-feedback">{modalErrors.emailId?.message}</div>
                
                          {/* Website */}
                          <input
                            type="text"
                            name="website"
                            {...registerModal("website")}
                            placeholder="Website URL"
                            className="form-control basic-form mt-3"
                          />
                
                          {/* Tier */}
                          <select
                            {...registerModal("tierType")}
                            className="form-control basic-form mt-3"
                          >
                            <option value="">Select Tier</option>
                            {tier.map((item, index) => (
                              <option key={index} value={item.tierName}>
                                {item.tierName}
                              </option>
                            ))}
                          </select>
                        </div>
                
                        {/* Right Column */}
                        <div className="col-md-6">
                          {/* Phone */}
                          <input
                            type="text"
                            name="phone"
                            placeholder="Mobile Number"
                            {...registerModal("phone")}
                            className={`form-control basic-form mt-3`}
                          />
                
                          {/* Company */}
                          <input
                            type="text"
                            name="company"
                            {...registerModal("company")}
                            placeholder="Company Name"
                            className="form-control basic-form mt-3"
                          />
                
                          {/* Description */}
                          <textarea
                            name="description"
                            {...registerModal("description")}
                            placeholder="Description"
                            className="form-control basic-form mt-3"
                          />
                
                          {/* Type */}
                          <select
                            {...registerModal("type")}
                            className={`form-control basic-form mt-3`}
                          >
                            <option value="">Select Type</option>
                            {type.map((item, index) => (
                              <option key={index} value={item.statusName}>
                                {item.statusName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>
                
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Cancel
                    </Button>
                  <Button
                  type="submit"
                  variant="primary"
                  onClick={handleSubmitModal(onSubmitStaffingContact)}
                  disabled={isSubmitting}
                >
                  {isSubmitting && (
                    <span className="spinner-border spinner-border-sm me-1"></span>
                  )}
                  Save
                </Button>
                
                  </Modal.Footer>
                </Modal>
                <style>
                    {`.field-section {
  padding: 10px 0;
}

.section-title {
  font-weight: 600;
  margin-bottom: 15px;
}

.field-col {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.custom-check {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.custom-check input[type="checkbox"] {
  transform: scale(1.2);
  margin-top: 0.1rem;
}

.form-check-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
}
`}
                </style>
            </section>
        </ConsultantLayout>
    );
};

export default ShareBenchCandidateDettoRecruiter;
